import { createSagaActionTypes } from '../../../utils/actionFactory';

export const GET_SUBSCRIPTIONS = 'GET_SUBSCRIPTIONS';
export const GET_ACCOUNTS = 'GET_ACCOUNTS';

export const actions = createSagaActionTypes('SUBSCRIPTIONS', [
  GET_ACCOUNTS,
  GET_SUBSCRIPTIONS
]);
